import { useTranslation } from 'react-i18next';
import { AsyncNotification } from '@asset-metrix/portal-ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteAllNavigationCustomization } from '../../api/portalGateway/navigationCustomization';

import { navigationCustomizationOptions } from './useNavigationCustomizationQuery';

export function useDeleteAllNavigationCustomizationMutation() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: deleteAllNavigationCustomization,
    onError: (error) => {
      AsyncNotification.show(
        { message: t('app.navigation.dynamicNavSection.errorNotification') },
        'error'
      );
      console.error('Failed to delete all navigation customizations:', error);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: navigationCustomizationOptions().queryKey,
      });
    },
  });
}
